export enum CookiesType {
    TempUser = 'tempUser',
    CheckoutEmail = 'checkoutEmail',
}
